module.exports = __webpack_public_path__ + "img/about_photo.c5b066a7.png";